import React, {FC, memo, useEffect, useState} from "react";
import {Dropdown, NavDropdown} from "react-bootstrap";
import {Outlet, useNavigate} from "react-router-dom";
import NavButton from "../../component/navButton/NavButton";
import MainLabel from "../../component/mainLabel/MainLabel";

import cameraIcon from "../../image/camera.png"
import fileIcon from "../../image/files.png"
import homeIcon from "../../image/home.png"
import settingsIcon from "../../image/settings.png"
import {BoxArrowRight, List, PersonFill} from "react-bootstrap-icons";
import {Container, HeaderContainer, NavContainer} from "./HeaderStyle";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import HeaderMenuItem from "../../component/headerMenuItem/HeaderMenuItem";
import {DropdownItem, DropdownMenu, DropdownToggle} from "../../component/headerMenuItem/HeaderMenuItemStyle";
import {actions, IToken} from "../../store/sliceToken";
import {config} from "../../config";
import {fetchUser} from "../../fetch/AuthRequest";

const Header: FC = () => {

    const nav = useNavigate()
    const dispatch = useDispatch<AppDispatch>();
    const {files, cameras, home} = useSelector((state: IRootState) => state.app)

    const token: IToken = useSelector((state: IRootState) => state.token)
    const [ath, setAuth] = useState(false)


    useEffect(() => {
        if (token.expire == null ) {
            nav(`${config.uiStart}/auth`)
        } else {
            fetchUser().then(response => {
                if(response.status == 200) {
                    setAuth(true)
                }
            })
        }
    }, [])

    return (
        <Container as={"main"}>
            <HeaderContainer>
                <MainLabel/>
                <NavContainer>
                    <NavButton name={"Файлы"} image={fileIcon} link={`${config.uiStart}/files`} focus={files}/>
                    <NavButton name={"Камеры"} image={cameraIcon} link={`${config.uiStart}/cameras`} focus={cameras}/>
                    <NavButton name={"Дом"} image={homeIcon} link={`${config.uiStart}/smart-home`} focus={home}/>
                </NavContainer>

                <DropdownMenu>
                    <DropdownToggle>
                        <List size={40}/>
                    </DropdownToggle>
                    <Dropdown.Menu>
                        <NavDropdown.Item style={{display: "flex", justifyItems: "center", alignItems: "center"}}>
                            <PersonFill/>
                            <HeaderMenuItem image={""} name={"Профиль"} link={`${config.uiStart}/profile`}/>
                        </NavDropdown.Item>
                        <NavDropdown.Item>
                            <HeaderMenuItem image={settingsIcon} name={"Настройки"} link={`${config.uiStart}/settings`}/>
                        </NavDropdown.Item>
                        <DropdownItem>
                            <NavDropdown.Divider/>
                            <NavDropdown.Item>
                                <HeaderMenuItem image={fileIcon} name={"Файлы"} link={`${config.uiStart}/files`}/>
                            </NavDropdown.Item>
                            <NavDropdown.Item>
                                <HeaderMenuItem image={cameraIcon} name={"Камеры"} link={`${config.uiStart}/cameras`}/>
                            </NavDropdown.Item>
                            <NavDropdown.Item>
                                <HeaderMenuItem image={homeIcon} name={"Дом"} link={`${config.uiStart}/smart-home`}/>
                            </NavDropdown.Item>
                        </DropdownItem>
                        <NavDropdown.Divider/>
                        <NavDropdown.Item style={{display: "flex", justifyItems: "center", alignItems: "center"}} onClick={() => dispatch(actions.clear())}>
                            <BoxArrowRight/>
                            <HeaderMenuItem name={"Выход"} link={`${config.uiStart}/auth`}/>
                        </NavDropdown.Item>
                    </Dropdown.Menu>
                </DropdownMenu>
            </HeaderContainer>
            {ath && <Outlet/>}
        </Container>
    )
}

export default memo(Header)
